import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';

import { AuthService } from '../services/auth.service';
import { ErrorConstant } from '../constant/error_constant';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastrService: NbToastrService,
  ) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {

    const token = this.authService.getToken();

    const authRequest = token
      ? request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      })
      : request;

    return next.handle(authRequest).pipe(
      catchError((error: HttpErrorResponse) => {

        if (!(error instanceof HttpErrorResponse)) {
          return throwError(() => error);
        }

        const apiMessage =
          error.error?.message ||
          error.error?.error ||
          error.message ||
          'Something went wrong';

        console.error('HTTP Error:', error.status, apiMessage);

        switch (error.status) {

          case 401:
          case 403:
            this.toastrService.danger(
              apiMessage || ErrorConstant.unauthorized_message,
              ErrorConstant.unauthorized
            );

            this.authService.logout();
            this.router.navigate(['/auth/login']);
            break;

          default:
            // 🔥 IMPORTANT: show API message for other errors
            this.toastrService.danger(apiMessage, 'Error');
            break;
        }

        // 🔑 let component still receive the error
        return throwError(() => error);
      })
    );
  }
}
